<template>
	<div class="actualizar-datos-nacional">
		<img src="../../assets/logo.svg" alt="Nacional Ticketing" class="escudo-nacional">
		<h2>Ocurrió un Error</h2>
		<p>Tus datos en nacional.uy están vacíos o son incorrectos.</p>
		<p>Asegurate de cargar tu nombre, apellido y documento de identidad sin puntos ni guíones (ejemplo: 12345678) e intenta de vuelta.</p>
		<a href="https://nacional.uy/es/profile/account" class="btn">Modificar perfil</a>
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>
	.actualizar-datos-nacional{
		background: url('../../assets/sports-player-background.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		width: 100vw;
		height: 100vh;
		margin: 0;
		padding: 24px;
		@include flex(column, center, center);

		.escudo-nacional{
			width: 80px;
			height: auto;
			margin-bottom: 20px;
		}
		
		h2{
			font-family: var(--font-family-poppins);
			font-weight: var(--font-weight-bold);
			text-transform: uppercase;
			font-size: 32px;
			color: var(--color-white);
			margin: 0;
			text-align: center;
		}

		p{
			margin: 6px 0;
			font-family: var(--font-family-fira);
			font-size: 18px;
			color: var(--color-white);
			text-align: center;
		}

		.btn{
			@include flex(row, center, center);
			text-transform: uppercase;
			font-family: var(--font-family-poppins);
			font-weight: var(--font-weight-bold);
			position: relative;
			cursor: pointer;
			background-color: var(--color-red);
			color: var(--color-white);
			-webkit-transition: background-color .2s ease;
			transition: background-color .2s ease;
			-webkit-letter-spacing: 0;
			-moz-letter-spacing: 0;
			-ms-letter-spacing: 0;
			letter-spacing: 0;
			min-height: 48px;
			padding: 0 24px;
			font-size: 16px;
			line-height: 25px;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
			outline-color: transparent;
			outline: none;
			box-shadow: none;
			border: 0;
			margin: 0;
			margin-top: 32px;
			text-decoration: none;

			&:hover{
				opacity: 0.9;
			}
		}
	}
</style>